import Table from "../../components/common/table/Table";
import {
  MESSAGES,
  STORE_GROUP_HEADER_DATA,
  STYLES,
  TABLE_CONFIG,
} from "./storeConstants";
import "./storeManagement.scss";
import { transformGroupsToRowData } from "./storeUtils";

const StoreGroupsTable = ({
  storeGroups,
  loading,
  onViewGroup,
  onEditGroup,
  onDeleteGroup,
}) => {
  const rowData = transformGroupsToRowData(
    storeGroups,
    onViewGroup,
    onEditGroup,
    onDeleteGroup
  );

  if (loading) {
    return <div style={STYLES.loadingContainer}>{MESSAGES.LOADING}</div>;
  }

  return (
    <div className="store-groups-table-container">
      <Table
        headerData={STORE_GROUP_HEADER_DATA}
        rowData={rowData}
        className="store-groups-table"
        pagination={true}
        rowsPerPage={TABLE_CONFIG.ROWS_PER_PAGE}
        noDataLabel="No store groups available"
      />
    </div>
  );
};

export default StoreGroupsTable;
